import { Badge } from "@/components/ui/badge";

// MobiMed semantic status mapping (kept independent from ad-hoc per-screen colors)
const MAP = {
  // drug schedule
  OTC: "mm-badge-success",
  POM: "mm-badge-warning",
  CONTROLLED: "mm-badge-error",
  // stock status
  ok: "mm-badge-success",
  low: "mm-badge-warning",
  out: "mm-badge-error",
  // customer type
  cash: "mm-badge-success",
  corporate: "mm-badge-neutral",
  insurance: "mm-badge-info",
  // payment status
  pending: "mm-badge-warning",
  paid: "mm-badge-success",
  on_account: "mm-badge-neutral",
  partial_claim: "mm-badge-info",
  // transfer status
  requested: "mm-badge-neutral",
  draft: "mm-badge-neutral",
  dispatched: "mm-badge-warning",
  received: "mm-badge-success",
  discrepancy: "mm-badge-error",
  pending_approval: "mm-badge-warning",
  resolved: "mm-badge-info",
  // claim / return status
  submitted: "mm-badge-info",
  rejected: "mm-badge-error",
  credited: "mm-badge-success",
  closed: "mm-badge-neutral",
  // location type
  warehouse: "mm-badge-neutral",
  branch: "mm-badge-info",
};

export function StatusBadge({ value, label, className = "", ...props }) {
  const cls = MAP[value] || "mm-badge-neutral";
  const LABELS = { pending_approval: "awaiting approval" };
  return (
    <span className={`mm-badge ${cls} ${className}`} {...props}>
      {label || LABELS[value] || value}
    </span>
  );
}
